import { TFilterSortBy } from '../types';

export enum actionTypes {
    GAMES_GRID_FEED_UPDATE = 'GAMES_GRID:FEED:UPDATE',
    GAMES_GRID_FILTERS_RESET = 'GAMES_GRID:FILTERS:RESET',
    GAMES_GRID_FEED_NAME_UPDATE = 'GAMES_GRID:FEED_NAME:UPDATE',
    GAMES_GRID_FAVORITES_UPDATE = 'GAMES_GRID:FAVORITES:UPDATE',
    GAMES_GRID_IS_LOADING_TOGGLE = 'GAMES_GRID:IS_LOADING:TOGGLE',
    GAMES_GRID_ACTIVE_TAB_UPDATE = 'GAMES_GRID:ACTIVE_TAB:UPDATE',
    GAMES_GRID_FILTERS_ALL_UPDATE = 'GAMES_GRID:FILTERS:ALL:UPDATE',
    GAMES_GRID_FILTERS_LABELS_UPDATE = 'GAMES_GRID:FILTERS:LABELS:UPDATE',
    GAMES_GRID_FILTERS_SORT_BY_UPDATE = 'GAMES_GRID:FILTERS:SORT_BY:UPDATE',
    GAMES_GRID_FILTERS_CATEGORY_UPDATE = 'GAMES_GRID:FILTERS:CATEGORY:UPDATE',
    GAMES_GRID_FILTERS_PROVIDERS_UPDATE = 'GAMES_GRID:FILTERS:PROVIDERS:UPDATE',
    GAMES_GRID_FILTERS_CUSTOM_FIELD_UPDATE = 'GAMES_GRID:FILTERS:CUSTOM_FIELD:UPDATE',
    GAMES_GRID_FILTERS_FILTER_POPUP_TOGGLE = 'GAMES_GRID:FILTERS:FILTER_POPUP:TOGGLE',
    GAMES_GRID_RECENTLY_PLAYED_CATEGORY_UPDATE = 'GAMES_GRID:RECENTLY_PLAYED_CATEGORY:UPDATE'
}

export const DEFAULT_FILTERS_STATE = {
    filterLabels: '',
    filterCategory: '',
    filterProviders: '',
    filterCustomFields: {},
    filterSortBy: 'default' as TFilterSortBy
};
